import { loadFixture, parseBody, mergeEntity } from '../mockDataStore';

export default function registerAuthMocks(mock) {
  // Login accepts any credentials in demo mode.
  mock.onPost(/^\/?api\/v1\/oauth\/token\/?$/).reply(async () => {
    const token = await loadFixture('auth/token');
    return [200, token];
  });

  mock.onPost(/^\/?api\/v1\/users\/update-last-login\/?$/).reply(() => [200, {}]);

  mock.onGet(/^\/?api\/v1\/profiles\/0\/?$/).reply(async () => {
    const currentUser = await loadFixture('auth/current-user');
    return [200, currentUser];
  });

  mock.onPatch(/^\/?api\/v1\/profiles\/0\/?$/).reply(async (config) => {
    const currentUser = await loadFixture('auth/current-user');
    mergeEntity(currentUser, parseBody(config), ['profile_picture']);
    return [200, currentUser];
  });

  mock.onPost(/^\/?api\/v1\/groups\/[\w-]+\/signup\/?$/).reply(async () => {
    const currentUser = await loadFixture('auth/current-user');
    return [201, currentUser];
  });

  mock.onGet(/^\/?api\/v1\/username-exists/).reply(() => [200, { exists: false }]);

  mock.onPost(/^\/?api\/v1\/password\/reset\/?$/).reply(() => [200, {}]);

  mock.onPost(/^\/?api\/v1\/password\/reset\/confirm\/?$/).reply(() => [200, {}]);
}
